import React from "react";

const Bookings = () => {
  return <div className="page-content">Bookings</div>;
};

export default Bookings;
